<template>
  <div style="height: auto;overflow: hidden;">
    <div class="footer">
      <div class="w_1400">
        <p><a href="https://beian.miit.gov.cn/#/Integrated/index">京ICP备16038139号</a>|环球青藤劳动教育研究院 版权所有</p>
        <p>北京市海淀区知春路7号致真大厦D座四层，邮编：100191</p>
        <!-- <p>友情链接: <a href="">中小学教师资格考试网阳光招生服务平台</a><a href="">北京教音考试院奥鹏教育</a><a href="">国家开放大学学习网</a></p> -->
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'footers',
    data() {
      return {

      }
    },
    methods: {

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url('../assets/css/home.css');
</style>



// WEBPACK FOOTER //
// src/components/footers.vue